export class Queue {
    nombre: string;
    notificacion: boolean = false;
    estrategia: string = 'rrmemory';
    timeout : string = '12';
    modelo : string;
    enEspera: string = 'default';
    servicelevel = 60;
    poll = ''
    directo? = ''
    //
    agentes: string | {idagente: string}[] = [];
    
    constructor(){} 
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./common/queue.ts